module.exports = __webpack_public_path__ + "media/search/multifamily_grayscale-8f2f81ba.png";